export default __webpack_public_path__ + "static/media/pdf.102e974b.svg";